<template>
  <div class="purchaseView">
    <img src="@/assets/images/img-purchase.png" class="purchaseImg" />
    <div class="purchaseContent_father">
      <div class="purchaseContent">
        <div class="purchase">
          <div class="purchase_content_area_01">
            <div class="area_01_card_01">
              <div class="text">会员</div>
              <div class="text">类型</div>
            </div>
            <div class="area_01_card_02" v-for="(cardItem, index) in cardData.data" :key="index">
              <mpCardBuy
                :item="cardItem"
                :cilckItem="selectCard"
                :isActive="cardData.active === index"
                :id="index"
              ></mpCardBuy>
            </div>
          </div>
          <div class="purchase_content_area_02">
            <div class="area_01_card_01">
              <div class="title">优惠码：</div>
              <div class="content">
                <router-link to="#">点击获取抵扣码</router-link>
              </div>
            </div>
            <div class="area_01_card_01">
              <div class="subtitle">支付金额：</div>
              <div class="content face">￥{{ cardData.data[cardData.active].salePrice }}</div>
            </div>
            <div class="area_01_card_02">
              <div class="title">支付方式</div>
              <div class="content">
                <mpCardBuyWay
                  v-for="(payItem, indexs) in payWay"
                  :key="indexs"
                  :item="payItem"
                  :isActive="payWayIndex === indexs"
                  :cilckItem="selectWay"
                  :id="indexs"
                ></mpCardBuyWay>
              </div>
            </div>
            <div class="area_01_card_02">
              <div class="subtitle">二维码</div>
              <div class="content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mpCardBuy from "@/components/mp-card-buy/mp-card-buy.vue";
import mpCardBuyWay from "@/components/mp-card-buy-way/mp-card-buy-way.vue";
export default {
  components: {
    mpCardBuy,
    mpCardBuyWay
  },
  data() {
    return {
      cardData: {
        active: 0,
        data: [
          {
            tip: false,
            title: "免费会员",
            desc: "数据分析学习者",
            salePrice: "0",
            costPrice: null,
            explain: "限制分析数据100条"
          },
          {
            tip: true,
            title: "月费会员",
            desc: "个人用户",
            salePrice: "9.9",
            costPrice: "19.9",
            explain: "畅享平台全部功能"
          },
          {
            tip: true,
            title: "年费会员",
            desc: "个人，团队",
            salePrice: "49",
            costPrice: "199",
            explain: "畅享平台全部功能"
          }
        ]
      },
      payWayIndex: 0,
      payWay: [
        {
          icon: "#icon-mpai-alipay",
          name: "支付宝"
        },
        {
          icon: "#icon-mpai-wechat",
          name: "微信"
        }
      ]
    };
  },
  methods: {
    selectCard(index) {
      this.cardData.active = index;
      console.log("salePrice",this.cardData.data[index].salePrice)
    },
    selectWay(index) {
      this.payWayIndex = index;
    }
  }
};
</script>

<style lang="less" scoped>
.purchaseView {
  .purchaseImg {
    width: 100%;
  }
  .purchaseContent_father {
    display: flex;
    justify-content: center;
    height: 500px;
    padding-top: 0px;
    margin-top: 0px;
    .purchaseContent {
      display: flex;
      justify-content: center;
      height: 500px;
      padding-top: 0px;
      margin-top: 0px;
      min-width: 1024px;
      width: 85%;
      .purchase {
        min-width: 900px;
        width: 85%;
        padding: 25px 30px;
        .purchase_content_area_01 {
          width: 100%;
          display: flex;
          justify-content: space-between;
          height: 156px;
          .area_01_card_01 {
            width: 156px;
            background: white;
            border-radius: 7px;
            box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
            padding: 30px;
            line-height: 48px;
            .text {
              width: 96px;
              font-size: 35px;
              color: #5bb7fe;
              font-weight: bold;
              letter-spacing: 12px;
              text-align: center;
            }
          }
          .area_01_card_02 {
            width: 25%;
          }
        }
        .purchase_content_area_02 {
          margin: 35px 0;
          border-radius: 7px;
          box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
          background: white;
          min-height: 240px;
          padding: 20px;
          .area_01_card_01 {
            width: 100%;
            padding: 15px 0;
            display: flex;
            justify-content: flex-start;
            .title {
              font-size: 18px;
              color: black;
              font-weight: bold;
              letter-spacing: 8px;
            }

            .subtitle {
              font-size: 18px;
              color: black;
              font-weight: bold;
              letter-spacing: 1px;
            }
            .face {
              color: #f56c6c;
              font-size: 20px;
            }
            .content a {
              color: #909399;
              text-decoration: none;
              font-size: 16px;
            }
            .content a:hover {
              color: #409eff;
              text-decoration: none;
            }
          }
          .area_01_card_02 {
            width: 100%;
            padding: 10px 0;
            padding-left: 35px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .title {
              font-size: 16px;
              letter-spacing: 1px;
            }
            .subtitle {
              font-size: 16px;
              letter-spacing: 8px;
            }
            .content {
              display: flex;
              justify-content: flex-start;
              align-items: center;
            }
          }
        }
      }
    }
  }
}
.card_content_area {
}
</style>
